import Navbar from 'components/MainApp/layout/NavBar';
import { PageContext } from 'contexts/TimerAppContexts/PageContext';
import { useAuth } from 'hooks/auth';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { LOGIN } from 'lib/routes';
import React, { useContext, useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import TreePilotLoading from '../TreePilotLoading';

const Layout = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate()
    const { currentPage, setCurrentPage } = useContext(PageContext);

    const { user, isLoading } = useAuth()


    useEffect(() => {
        if (!isLoading && pathname.startsWith("/protected") && !user) {
            navigate(LOGIN)
        }
    }, [pathname, user, isLoading])


    // useEffect(() => {
    //     setCurrentPage(pathname.split('/').at(-1))
    // }, [pathname])

    if (isLoading) return <TreePilotLoading />;


    return (
        <>
            <div className="app-main-container">
                <Navbar />
                <div className="outlet-container">
                    <Outlet />
                </div>
            </div>
        </>
    )
}

export default Layout